import { apiRoutes } from 'hashtags/utils/apiRoutes';
import { apiRoutes as apiRoutesPosts } from 'posts/utils/apiRoutes';
import {
  entitiesApiRoutes,
  influencerApiRoutes,
} from 'influencers/utils/apiRoutes';

const hashtagsFilters = [
  { key: 'ORIGINAL', value: 'is_original' },
  { key: 'RETWEET', value: 'is_retweet' },
  { key: 'REPLY', value: 'is_reply' },
];

const platformApiMap: any = (isInfluencerModule: boolean) => ({
  twitter: isInfluencerModule
    ? influencerApiRoutes().twitterTweetsTab
    : entitiesApiRoutes().twitterTweetsTab,

  youtube: isInfluencerModule
    ? influencerApiRoutes().youtubeVideosTab
    : entitiesApiRoutes().youtubeVideosTab,
  author: isInfluencerModule
    ? influencerApiRoutes().articlesNewsTab
    : entitiesApiRoutes().articlesNewsTab,
});

const platformApiMapHashtag: any = {
  tweets: apiRoutes().hashtagTweets,
  youtube: apiRoutes().hashtagVideos,
  linkedin: apiRoutes().hashtagLinkedInPosts,
  instagram: apiRoutes().hashtagInstaPosts,
  tiktok: apiRoutes().hashtagTiktokPosts,
};

const platformApiMapPosts: any = {
  instagram: apiRoutesPosts.instagramPostCommentsTab,
  tiktok: apiRoutesPosts.tiktokPostCommentsTab,
  linkedin: apiRoutesPosts.linkedinCommentsTab,
  youtube: apiRoutesPosts.youtubePostCommentsTab
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getInfTweetsFilters = (item: any): any => {
  const filters = hashtagsFilters?.filter(
    (filter) => filter?.key === item?.tweet_type?.value,
  );
  const selectedFilters =
    filters?.map((item) => ({ [item.value]: true }))?.[0] || {};
  return selectedFilters;
};

export const getInfTweetsInfoFromSlug = (
  slug: string,
  isInfluencerModule: boolean,
  isHashtag?: boolean,
  isPosts?: boolean,
): any => {
  const PLATFORMS = [
    'twitter',
    'youtube',
    'linkedin',
    'author',
    'tweets',
    'instagram',
    'tiktok',
  ];
  const TYPES = ['negative', 'neutral', 'positive', 'all'];

  const type = TYPES.filter((type) => slug.includes(type))[0];
  const platform = PLATFORMS.filter((platform) => slug.includes(platform))[0];
  return {
    type,
    requestUrl: isHashtag
      ? platformApiMapHashtag[platform]
      : isPosts
        ? platformApiMapPosts[platform]
        : platformApiMap(isInfluencerModule)?.[platform],
  };
};
